import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../../../baseComponent.js";
import styles from "./tab.scss";

export default class Tabs extends BaseComponent {
  constructor(props) {
    super(props);
    this.tabs = props.tabs;
    this.state = {
      activeTabIndex: 0
    }
  }

  componentDidMount() {
    if(this.props.control == null){
      this.renderContent(this.tabs[0].component, this.tabs[0].props);
    }
    else{
      if (this.props.control.tabSelect != null) {
        this.renderContent(this.tabs[this.props.control.tabSelect].component, this.tabs[this.props.control.tabSelect].props);
        this.setState({activeTabIndex: this.props.control.tabSelect});
      }
    }
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.refs.tabContent);
  }

  onTabClick(event) {
    let $target = $(event.currentTarget);
    let tabIndex = parseInt($target.attr("data-tab-index"));
    this.setState({
      activeTabIndex: tabIndex
    });
    this.renderContent(this.tabs[tabIndex].component, this.tabs[tabIndex].props);
  }

  renderContent(component, props) {
    let contentComponent = React.createElement(component, props);
    ReactDOM.unmountComponentAtNode(this.refs.tabContent);
    ReactDOM.render(contentComponent, this.refs.tabContent);
  }

  render() {
    let tabButtons = this.tabs.map((tab, index) => {
      let className = index === this.state.activeTabIndex ? styles.activeTab : styles.tab;

      if(this.props.control == null) {
        return <div className={className}
                    data-tab-index={index}
                    onClick={(e) => this.onTabClick(e)}
                    key={"tab-" + index}>
          <div className={styles.tabLine}></div>
          <span>{this.tabs[index].title}</span>
        </div>;
      }
      else {
        if (this.props.control.tabDoNotDisplay != index) {
          return <div className={className}
                      data-tab-index={index}
                      onClick={(e) => this.onTabClick(e)}
                      key={"tab-" + index}>
            <div className={styles.tabLine}></div>
            <span>{this.tabs[index].title}</span>
          </div>;
        }
      }
    });

    return (
      <div className={styles.container}>
        <div className={styles.tabs}>
          {tabButtons}
          <div className={styles.space}></div>
        </div>
        <div className={styles.tabContent} ref="tabContent">
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/content/tabs.jsx